var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 920.000000 980.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,980.000000) scale(0.100000,-0.100000)",
    fill: "#878787",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4355 9790 c-745 -55 -1460 -367 -2006 -876 -952 -887 -1298 -2233 -889 -3464 77 -232 171 -438 300 -655 26 -44 51 -91 55 -103 8 -27 249 -331 346 -437 35 -39 530 -628 1101 -1310 570 -682 1058 -1261 1085 -1287 123 -120 356 -130 490 -20 24 19 125 134 226 256 1076 1298 1839 2213 1933 2314 196 212 308 359 436 572 575 954 634 2132 158 3127 -494 1031 -1455 1724 -2589 1868 -149 18 -493 27 -646 15z m535 -1794 c360 -100 653 -375 770 -724 138 -411 31 -857 -278 -1160 -434 -424 -1130 -424 -1564 0 -454 445 -449 1171 10 1610 158 151 329 241 547 288 134 29 382 22 515 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2516 2674 c-1071 -183 -1879 -805 -1741 -1339 67 -257 304 -494 706 -704 1071 -559 2894 -773 4484 -526 1238 193 2166 613 2405 1090 69 138 84 241 55 378 -94 445 -761 889 -1610 1072 -88 19 -180 35 -204 37 l-43 3 -158 -273 c-146 -250 -157 -272 -137 -277 12 -3 77 -16 143 -30 540 -112 1022 -324 1174 -517 76 -96 74 -173 -8 -260 -280 -300 -1343 -569 -2517 -638 -222 -13 -755 -13 -981 0 -1385 80 -2584 456 -2529 794 18 107 143 255 310 364 242 159 636 292 1015 343 52 7 96 14 98 15 4 2 -296 463 -312 480 -8 9 -46 6 -150 -12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.fad9dc1452c98119fbbcae4583b36bfd.svg";
export { ForwardRef as ReactComponent };